import { render, staticRenderFns } from "./PromoBannerEarly.vue?vue&type=template&id=2aa88566&"
import script from "./PromoBannerEarly.vue?vue&type=script&lang=js&"
export * from "./PromoBannerEarly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports